import { Navigate } from 'react-router-dom'

/** Rota legada: redireciona para o detalhamento completo */
export default function GestorDespesasRedirectPage() {
  return <Navigate to="/gestor/detalhamento" replace />
}
